
// Define multiple base URLs as an object
const BASE_URLS = {

  // Server link
  // main: 'http://localhost/websites/b2c_stripe/webadmin/api/',
  main: 'https://pre-prod-b2c.rathin.com/webadmin/api/',
  webUrl: '/',
  
  payUrl: 'https://pre-prod-b2c.rathin.com/',
  // payUrl: 'http://localhost/websites/b2c_stripe/',
  stripeKey: 'pk_live_51PaEFlDoNoJ3VD6oQaF0vPtKLNxpi9PSxxIC4Jxs0i1Vdkc7VZNmZDPjWfA8yNL0wDmGgcxPMqpUteDhpb3qwC9m008OgrOEvg',
  // stripeKey: 'pk_test_51PaEFlDoNoJ3VD6oof6QcjUUEm0iaicPuyRq2AB2UF1TFk4Z5icqgUXHM0R8UNTBGvoEMsQg0MQr9TrYxIr6dfgV00VzMZ9vYR',
};
export default BASE_URLS;
